import { atom } from "jotai";

export const showShareModalAtom = atom(false);
export const showLightboxAtom = atom(false);
